module.exports = __webpack_public_path__ + "media/images/flags/JO-4ec3fbceccdadcddf41fbeba1b4b3ce0.svg";